import { sortBy } from 'lodash'

// Carried over from the announcements form: helpers for the workout button picker.

export const getProgramWorkoutsLoading = ({ isWorkoutButton, programId, programWorkoutsData }) => {
  return Boolean(isWorkoutButton && programId && (programWorkoutsData === undefined || programWorkoutsData?.isLoading))
}

// A workout on a multi-workout day takes its day from the program's `multiWktDays`, as
// the App Layout picker does, so each workout comes back with the `dayIdx` it is shown on.
export const getAvailableProgramWorkouts = (programWorkoutsData, multiWktDaysData) => {
  if (!programWorkoutsData || programWorkoutsData?.isLoading) {
    return {}
  }

  const multiWktDays = multiWktDaysData?.isLoading ? {} : multiWktDaysData || {}

  const workoutEntries = Object.entries(programWorkoutsData)
    .filter(([_, workout]) => workout && typeof workout === 'object' && workout?.type !== 'rest')
    .map(([workoutId, workout]) => {
      const multiWktDay = multiWktDays[workout.multiWktDayId]
      return [workoutId, multiWktDay ? { ...workout, dayIdx: multiWktDay.dayIdx } : workout]
    })

  // In program day order, so the picker can be browsed without a search term, and a
  // multi-workout day in its own order. A workout with no day goes last.
  const sortedEntries = sortBy(
    workoutEntries,
    ([_, workout]) => (Number.isFinite(workout.dayIdx) ? workout.dayIdx : Infinity),
    ([workoutId, workout]) => multiWktDays[workout.multiWktDayId]?.workouts?.indexOf(workoutId) ?? 0
  )

  return Object.fromEntries(sortedEntries)
}

// The "Week 2 | Day 3" line the App Layout picker shows under each workout.
export const getWorkoutDayLabel = (workout) => {
  const dayIdx = workout?.dayIdx
  if (!Number.isFinite(dayIdx)) {
    return ''
  }

  return `Week ${Math.floor(dayIdx / 7) + 1} | Day ${(dayIdx % 7) + 1}`
}

export const shouldClearWorkoutId = ({ buttonType, programId, workoutId, programWorkouts, programWorkoutsLoading }) => {
  if (buttonType !== 'workout' || !workoutId) {
    return false
  }

  if (programWorkoutsLoading) {
    return false
  }

  return !programId || !programWorkouts?.[workoutId]
}
